import { bridge } from './desktop';

/** Call from a user click. Desktop permissions deliberately deny the browser clipboard API. */
export async function copyText(text: string): Promise<void> {
  const desktop = bridge();
  if (desktop?.copyText) {
    await desktop.copyText(text);
    return;
  }
  if (!desktop && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Permission denied: try copying a selection without requesting clipboard access.
    }
  }

  const active = document.activeElement as HTMLElement | null;
  const selection = window.getSelection();
  const ranges = selection ? Array.from({ length: selection.rangeCount }, (_, i) => selection.getRangeAt(i).cloneRange()) : [];
  const field = document.createElement('textarea');
  field.value = text;
  field.readOnly = true;
  field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;font-size:16px';
  // Keep focus inside the current dialog while copying (also supports older desktop builds).
  (active?.closest('[role="dialog"]') ?? document.body).appendChild(field);
  try {
    field.select();
    if (!document.execCommand('copy')) throw new Error('Clipboard unavailable');
  } finally {
    field.remove();
    active?.focus({ preventScroll: true });
    if (selection) {
      selection.removeAllRanges();
      ranges.forEach((range) => selection.addRange(range));
    }
  }
}
